import { createContext } from 'react';

const CWPContext = createContext();
export default CWPContext;
